// extracted by mini-css-extract-plugin
module.exports = {"Container":"column-layout_Container__uXrJP","Header":"column-layout_Header__Z7sIH","Shape":"column-layout_Shape__6RBu8"};